import { render, staticRenderFns } from "./CustomDateSubmit.vue?vue&type=template&id=45af4306&scoped=true&"
import script from "./CustomDateSubmit.vue?vue&type=script&lang=js&"
export * from "./CustomDateSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af4306",
  null
  
)

export default component.exports